




































import { Component, Vue, Prop } from "vue-property-decorator";
import { util, biHottag } from '@tencent/ppd-base-libs';
import {hideLoading, showLoading} from '@/fit-components/loading/main';
import {showBusinessError} from '@/fit-components/dialog/main';
import LoadFailed from '@/components/load-failed.vue';
import { queryBusinessesConfig } from "../api";
import { sortString } from "@/utils";

@Component({
  components: { LoadFailed }
})
export default class BusinessQuery extends Vue {
  sourceData = [];
  keyword = '';
  loaded = false;
  loadFailed = false;

  get listData() {
    if (this.keyword === "") {
      return this.sourceData;
    }
    return this.sourceData.filter(item => {
      const isExist = (item as any).businessName.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1;
      return isExist;
    });
  }

  format(arr) {
    let array = arr.map(i => {
      // 中英文地址分开展示
      const arr = i.address.split('\r\n');
      let addr = arr[0];
      let enAddr = arr[1];
      if (enAddr) {
        i.address = addr;
        i.enAddress = enAddr
      }
      return i;
    });
    return sortString(array, 'businessName');
  }

  async created() {
    showLoading();
    this.loadFailed = false;
    const [data, err] = await util.to(queryBusinessesConfig());
    if(!data) {
      hideLoading();
      this.loadFailed = true;
      return;
    }
    // @ts-ignore
    this.sourceData = this.format(data.configList);
    hideLoading();
    this.loaded = true;
  }
  distoryed() {
    this.loaded = false;
    this.sourceData = [];
    this.keyword = '';
  }
}
